export const propsFilter = (propsToFilter: string[]) => {
  return (prop: string): boolean => !propsToFilter.includes(prop);
};
